<dialog-header [centered]="true">Request Changes</dialog-header>
<mat-dialog-content class="form-group tw-px-6">
  <p class="tw-mb-4">
    <strong>{{ editorName() }}</strong> has sent this presentation for review.
    Please provide clear, specific details so they can revise and resubmit the
    presentation.
  </p>
  <label class="tw-font-medium" for="details">Details</label>
  <textarea
    id="details"
    matInput
    rows="3"
    [(ngModel)]="details"
    placeholder="Describe the changes needed before resubmitting."
    class="form-control comments"
  ></textarea>
</mat-dialog-content>
<rv-divider class="tw-my-6" />
<mat-dialog-actions align="end">
  <button rv-button variant="secondary" [mat-dialog-close]="null">
    Cancel
  </button>
  <button rv-button [disabled]="!details" [mat-dialog-close]="result">
    Request Changes
  </button>
</mat-dialog-actions>
